// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FileUpload.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import FileUploadControl from 'react-fileupload';
import config from 'config';
import classNames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';
import IzendaConfig from 'Izenda.Config';

@connect()
export default class FileUpload extends Component {
  static propTypes = {
    options: PropTypes.object.isRequired,
    isHighLight: PropTypes.bool
  };

  static defaultProps = {
    isHighLight: false
  };

  /**
   * resolve url
   * @param {String} path 
   */
  resolveUrl(path: string) {
    const root = config.WebApiUrl;
    const safePath = path ? (path[0] === '/' ? path.substring(1) : path) : '';
    return root.concat(root.slice(-1) !== '/' ? '/'.concat(safePath) : safePath);
  }

  /**
   * @method getOptionsWithCustomSettings
   * @description attach custom AjaxSettings to FileUploadControl options prop
   */
  getOptionsWithCustomSettings() {
    const { options } = this.props;
    return {
      ...options,
      requestHeaders: {
        ...options.requestHeaders,
        ...IzendaConfig.AjaxSettings.headers || {}
      },
      ...IzendaConfig.AjaxSettings.xhrFields || {}
    };
  }

  render() {
    const { options, localization, className } = this.props;
    options.baseUrl = this.resolveUrl(options.baseUrl);

    const btnClass = classNames('btn', 'btn-primary', {
      'btn-success': this.props.isHighLight
    });

    return (
      <FileUploadControl options={this.getOptionsWithCustomSettings()} className={className}>
        <button ref="chooseAndUpload" className={btnClass}>
          {localization.getText('IMPORT_BROWSE')}
        </button>
      </FileUploadControl>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/FileUpload/Izenda.FileUpload.js